export default {
  title: 'Actualizați ora de livrare',
  labels: {
    dropoff_time: 'Ora de livrare',
    confirmed: 'Oră confirmată:',
    new_time: 'Oră nouă:',
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    success: 'Ora de livrare a fost actualizată',
    failed_to_save: 'Eroare la salvarea modificărilor',
  },
  alerts: {
    dropoff_time_info: 'Ora curentă și cea nouă sunt în fusul orar {{timezone}} al {{restaurantName}}',
  },
};
